// Recharts hands its onClick a state object; the clicked category lands in
// activeLabel. Every graph here indexes by an epoch-ms timestamp, so that is
// what comes back — as a number or a string, or missing entirely when the
// click hit empty chart background.
export const toClickedTimestamp = (rechartsState) => {
  const label = rechartsState?.activeLabel;
  const timestamp = Number(label);

  return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
};
